import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { MAIN_CONTENT_ID } from '@repo/atomic-components';

/**
 * Moves focus to `<main>` after client-side navigation. Skipped on initial load and when focus is still on the page.
 */
const useFocusMainOnRouteChange = () => {
  const { pathname } = useLocation();
  const previousPathnameRef = useRef<string | null>(null);

  useEffect(() => {
    const hasNavigated = previousPathnameRef.current !== null && previousPathnameRef.current !== pathname;
    previousPathnameRef.current = pathname;
    if (!hasNavigated) return;

    if (document.activeElement && document.activeElement !== document.body) return;

    document.getElementById(MAIN_CONTENT_ID)?.focus();
  }, [pathname]);
};

export { useFocusMainOnRouteChange };
